import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import {
  GetCurrentUserGQL,
  GetCurrentUserQuery,
} from '../graphql/generated/ala-backend.service';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor(private currentUserGQL: GetCurrentUserGQL) {}

  getCurrentUser(): Observable<GetCurrentUserQuery> {
    return this.currentUserGQL.fetch().pipe(
      map((result) => result.data),
      switchMap((data) =>
        data
          ? of(data as GetCurrentUserQuery)
          : throwError(() => new Error('No user data found'))
      )
    );
  }
}
